import { render, staticRenderFns } from "./InfiniteLoading.vue?vue&type=template&id=08a666dc&"
import script from "./InfiniteLoading.vue?vue&type=script&lang=js&"
export * from "./InfiniteLoading.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteLoading.vue?vue&type=style&index=0&id=08a666dc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports